export default "__VITE_ASSET__DZm2XNtn__"